<h3 class="mat-h3">Materias y Google Classroom</h3>
<table *ngIf="courses$ | async as courses; else loading" mat-table [dataSource]="mcps$ | async" style="min-width: 100%; margin: 24px 0;" class="mat-elevation-z2">
  <ng-container matColumnDef="materia">
    <th mat-header-cell *matHeaderCellDef>Materia</th>
    <td mat-cell *matCellDef="let element">
      {{element.nombreCompleto}}
    </td>
  </ng-container>
  <ng-container matColumnDef="accion">
    <th mat-header-cell *matHeaderCellDef>
      Classroom
    </th>
    <td mat-cell *matCellDef="let element">
      <!-- <button mat-button (click)="enlazar(element, element.classroomCourse ? false : true)">{{element.classroomCourse ? 'Desenlazar' : 'Enlazar'}}</button> -->
      <div *ngIf="courses">
      </div>
      <app-unidad-form-classroom-select [materia]="element" [courses]="courses" [editable]="unidad.isEditable" [actual]="element.classroomCourseId"></app-unidad-form-classroom-select>
    </td>
  </ng-container>
  <tr mat-header-row *matHeaderRowDef="['materia', 'accion'];"></tr>
  <tr mat-row *matRowDef="let row; columns: ['materia', 'accion'];"></tr>
</table>
<ng-template #loading>
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</ng-template>
